<div class="header">
  <div>
    Weather Events for Selected Counties
  </div>
  <button class="csv-btn" mat-stroked-button color="primary" (click)="onExportClick()">
    <vulcan-icon icon="file-csv" size="24px"></vulcan-icon>
  </button>
</div>
<table mat-table [dataSource]="dataSource" matSort matSortActive="state" matSortDisableClear matSortDirection="asc">

  <ng-container matColumnDef="state">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
    <td mat-cell *matCellDef="let row">{{ row.stateAbbreviation }}</td>
  </ng-container>

  <ng-container matColumnDef="county">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>County</th>
    <td mat-cell *matCellDef="let row">{{ row.county }}</td>
  </ng-container>

  <ng-container matColumnDef="phenom">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Weather Events</th>
    <td mat-cell #phenomList *matCellDef="let row" class="ellipsis phenom-list" [matTooltip]="row.weatherEventNames"
      [matTooltipDisabled]="!hasEllipsis(phenomList)">
      <span>{{row.weatherEventNames}}</span>
    </td>
  </ng-container>


  <ng-container matColumnDef="start_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Start</th>
    <td mat-cell *matCellDef="let row">{{ row.groupIssued.toDate() | date: 'short' }}</td>
  </ng-container>

  <ng-container matColumnDef="end_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Event End</th>
    <td mat-cell *matCellDef="let row">{{ row.groupExpired.toDate() | date: 'short' }}</td>
  </ng-container>


  <ng-container matColumnDef="extreme">
    <th mat-header-cell *matHeaderCellDef>Extreme</th>
    <td mat-cell *matCellDef="let row">
      <mat-icon>{{row.extreme? 'check': 'close'}}</mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="auc">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Area Under Curve</th>
    <td mat-cell *matCellDef="let row">{{ row.auc | number}}</td>
  </ng-container>

  <ng-container matColumnDef="tot">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Time over Threshold</th>
    <td mat-cell *matCellDef="let row">{{ row.tot | number }}</td>
  </ng-container>



  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns;"></tr>
</table>
<mat-paginator pageSize="5" hidePageSize aria-label="Select page of metrics"></mat-paginator>
